import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import Layout from "components/structure/Layout";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import EditIcon from "assets/editPencil.svg";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import RoleService from "services/RoleService";
import { useEffect } from "react";
import { useContext } from "react";
import { SnackbarContext } from "context/snackBarContext";
import { AuthData } from "auth/AuthWarpper";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";

import { useTranslation } from "react-i18next";
import AdministratorService from "services/AdministratorService";

const EditAdministrator = () => {
  
  const {t,i18n} = useTranslation()
  const location = useLocation();
  const [clickEdit, setClickEdit] = useState(false);
  const [clickStatus, setClickStatus] = useState(false);

  const [roleOptions, setRoleOptions] = useState([]);
  const { user } = AuthData();
  const { rowData } = location.state || {};
  const [isActive, setIsActive] = useState(rowData?.isActive === "Active");
  const [formData, setFormData] = useState({
    profile: "",
    fieldTechnician: "",
    role: rowData?.profileOwnerId || "",
    country: "",
    serviceNumber: rowData?.serviceNumber || "",
    remarks: rowData?.remarks || "",
  });


  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = React.useState(false);
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);

  const fetchRoles = async () => {
    try {
      const response = await AdministratorService.getActiveRoles();
      if (response.data?.statusCode === 200) {
        setRoleOptions(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const toggleIsActive = (status) => {
    setIsActive((prevIsActive) => !prevIsActive);
    setClickStatus(status);
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    // setLoading(true);
    try {
      // setErrors({});
      // await validationSchema.validate(formData, { abortEarly: false });

      // Constructing the payload object
      const payload = {
        profileId: rowData?.profileId,
        profileName: rowData.profileName,
        isActive: isActive,
        profileAttribute: rowData.profileAttribute,
        serviceNumber: formData.serviceNumber,
        remarks: formData.remarks,
        isDeleted: false,
        profileOwnerId: formData.role,
        createdByUser: user?.userName || "Raju",
        modifiedByUser: user?.userName || "Raju",
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
        roleFunctionality:rowData?.roleFunctionality?.split(', ')
      };

      // "profileName": "Role_Test_005",
      // "isActive": true,      This field is editable
      // "profileAttribute": "Local",
      // "serviceNumber": "XX77XX55DD", This field is editable
      // "remarks": "New Role creation",  This field is editable
      // "isDeleted": false,
      // "profileOwnerId": "76C20103-C412-4C43-92E1-4E2500C2EA2F", This field is editable
      // "createdDateTimeUTC": "2024-09-26T12:38:46.084Z",
      // "createdByUser": "Ray Raju",
      // "modifiedDateTimeUTC": "2024-09-26T12:38:46.084Z",
      // "modifiedByUser": "Ray Raju"

      // Make a POST request using Axios
      const response = await RoleService.updateRole(payload);

      if (response.status === 200) {
        // Show success snackbar
        navigate("/administratorCreation");
        setSeverity("success");
        setMessage("Updated successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        // Show error snackbar
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
      setLoading(false);
    }
  };

  // console.log("rowData", rowData);
  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "65vh",
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
            borderRadius: "6px",
          }}
        >
          <Box
            sx={{
              background: "#ffffff",
              width: "776px",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "16px",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            }}
          >
            <Box
              sx={{
                borderBottom: "2px solid #EDEFF3",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  p: 2,
                  color: "#191E31",
                  fontWeight: 700,
                  fontSize: "18px",
                }}
              >
                {rowData?.profileName}
              </Typography>
            </Box>

            <Box
              sx={{
                borderBottom: "2px solid #EDEFF3",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{ color: "#191E31", fontWeight: 700, fontSize: "18px" }}
              >
                {t("userCreation.country")}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pb: 2,
                  textAlign:"center"
                }}
              >
                <Typography sx={{ pb: 1, mt: 1, mr: 1 }}>
                  {rowData.countries}
                </Typography>
              </Box>
              <Typography
                sx={{ color: "#191E31", fontWeight: 700, fontSize: "18px" }}
              >
                {t("administratorAccess.attribute")}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pb: 2,
                }}
              >
                <Typography sx={{ pb: 1, mt: 1, mr: 1 }}>
                  {rowData?.profileAttribute}
                </Typography>
              </Box>
            </Box>
            
            <Box
              sx={{
                borderBottom: "2px solid #EDEFF3",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{ color: "#191E31", fontWeight: 700, fontSize: "18px" }}
              >
                {t("administratorAccess.profileOwnerName")}
               
              </Typography>
              {clickEdit === true ? (
                <Box sx={{ width: "60%", p: 2 }}>
                  <TextField
                    select
                    id="role"
                    label={t("administratorAccess.profileOwnerName")}
                    value={formData.role}
                    name="role"
                    onChange={handleChange}
                    fullWidth
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                          },
                        },
                      },
                    }}
                  >
                    {roleOptions.map((option) => (
                      <MenuItem
                        sx={{
                          maxHeight: "30px !important", // Control the height of individual items
                          fontSize: "16px", // Adjust font size for compact display
                        }}
                        key={option.id}
                        value={option.id}
                      >
                        {option.value}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pb: 2,
                  }}
                >
                  <Typography sx={{ pb: 1, mt: 1, mr: 1 }}>
                    {rowData?.profileOwnerName}
                  </Typography>

                  {/* <Box
                    sx={{
                      marginLeft: "5px",
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                      cursor: "pointer",
                    }}
                    onClick={() => setClickEdit(true)}
                  >
                    <img
                      src={EditIcon}
                      alt="Edit"
                      style={{ width: "60%", height: "60%" }}
                    />
                  </Box> */}
                </Box>
              )}
            </Box>
            <Box
              sx={{
                borderBottom: "2px solid #EDEFF3",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                pb:2
              }}
            >
              <Box sx={{display:"flex",alignItems:"center"}}>
              <Typography
                sx={{ color: "#191E31", fontWeight: 700, fontSize: "18px" }}
              >
                  {t("administratorAccess.roleFunctionality")}
              
              </Typography>
              <Box
                    sx={{
                      marginLeft: "5px",
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                      cursor: "pointer",
                    }}
                    // onClick={() => setClickEdit(true)}
                    onClick={() => navigate('/roleEdit',{state:{rowData:rowData ,fromUrl:"/administratorCreation"}})}

                  >
                    <img
                      src={EditIcon}
                      alt="Edit"
                      style={{ width: "60%", height: "60%" }}
                    />
                  </Box>
              </Box>
              
            
              <Typography sx={{maxWidth:"500px"}}>
                {rowData?.roleFunctionality}
              </Typography>
            </Box>
            <Box
              sx={{
                borderBottom: "2px solid #EDEFF3",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              {clickEdit === true ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    pb: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => toggleIsActive(!clickStatus)}

                >
                  <img
                    src={isActive ? CheckboxTick : CheckboxUntick}
                    alt="checkbox"
                  />
                  <Typography>{isActive ? "Active" : "Inactive"}</Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    pb: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => toggleIsActive(!clickStatus)}

                >
                  <img
                    src={isActive ? CheckboxTick : CheckboxUntick}
                    alt="checkbox"
                  />
                  <Typography>{isActive ? "Active" : "Inactive"}</Typography>
                </Box>
              )}
            </Box>


            {(clickEdit === true || clickStatus === true) && (
              <Box
                sx={{
                  borderBottom: "2px solid #EDEFF3",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <Box sx={{ width: "80%", pb: 2 }}>
                  <TextField
                    label={<span style={{ fontStyle: 'italic' }}>{t("serviceNumber")}</span>}
                    name="serviceNumber"
                    onChange={handleChange}
                    value={formData.serviceNumber}
                    fullWidth
                  />
                  <TextField
                    fullWidth 
                    label={<span style={{ fontStyle: 'italic' }}>{t("remarks")}</span>}
                    name="remarks"
                    onChange={handleChange}
                    value={formData.remarks}
                    multiline
                    rows={4}
                    sx={{ mt: 2 }}
                  />
                </Box>
              </Box>
            )}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                pb: 2,
              }}
            >
              <Button
                sx={{
                  borderRadius: 2,
                  background: "#737d86",
                  height: 54,
                  color: "#ffffff",
                  fontWeight: 600,
                  backgroundColor: "#737d86",
                  width: { xs: "100%", md: "156px" },
                  "&:hover": {
                    backgroundColor: "#737d86",
                  },
                }}
                onClick={() => navigate("/administratorCreation")}
              >
                {/* Back */}
                {t("back")}
              </Button>
              <Button
                sx={{
                  borderRadius: 2,
                  background: "#0A3575",
                  color: "#ffffff",
                  fontWeight: 600,
                  height: 54,
                  width: { xs: "100%", md: "156px" },
                  "&:hover": {
                    backgroundColor: "#8894b1",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#8894B1", // Custom disabled color
                    color: "#ffffff", // Custom text color when disabled
                  },
                }}
                onClick={handleUpdate}
                disabled={!clickStatus}
              >
                {/* Update */}
                {t("update")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </LayoutAccessManagement>
  );
};

export default EditAdministrator;
